
import React from 'react';
import { Link } from 'react-router-dom';
import { getTranslation as t, isRTL } from '../utils/translations';
import Image from './Image';

const CategorySection = ({ categories = [], highlightedNames = [] }) => {
    const highlightedSet = new Set(
        (highlightedNames || []).map(value => String(value).toLowerCase())
    );

    const renderInitials = (name) => {
        const safe = String(name || '').trim();
        if (!safe) return 'L';
        const words = safe.split(/\s+/).filter(Boolean).slice(0, 2);
        return words.map(part => part.charAt(0).toUpperCase()).join('');
    };

    return (
        <section className="section container category-story-section">
            <div className="section-header">
                <div>
                    <div className="section-kicker">{isRTL() ? 'المجموعات الفاخرة' : 'Luxury Categories'}</div>
                    <h2 className="section-title">{t('CATEGORIES')}</h2>
                    <div className="section-accent" />
                </div>
            </div>
            <div className="category-scroll" aria-label="Category stories">
                {categories.map(cat => {
                    const count = Number(cat.productCount ?? cat.count ?? 0);
                    const key = String(cat?.name || '').toLowerCase();
                    const highlighted = highlightedSet.has(key) || cat.showOnHome === true;
                    const catName = isRTL()
                        ? (cat.nameAr || cat.name_ar || cat.name)
                        : (cat.nameEn || cat.name_en || cat.name);
                    const catImg = cat.imageUrl || cat.image_url || cat.image;
                    return (
                        <Link
                            to={`/category/${cat.name || cat.slug}`}
                            key={cat.id || cat.name}
                            className={`category-card luxury-category-card ${highlighted ? 'highlighted' : ''}`}
                        >
                            <div className="category-card-media-wrapper">
                                {catImg ? (
                                    <Image src={catImg} alt={catName} lazy={true} className="category-card-img" />
                                ) : (
                                    <div className="category-card-fallback">{renderInitials(catName)}</div>
                                )}
                            </div>
                            <div className="category-card-content">
                                <span className="category-card-name">{catName}</span>
                            </div>
                        </Link>
                    );
                })}
                <Link to="/category/all" className="category-card luxury-category-card view-all-card">
                    <div className="category-card-media-wrapper view-all-wrapper">
                        <span className="view-all-icon">{isRTL() ? '←' : '→'}</span>
                    </div>
                    <div className="category-card-content">
                        <span className="category-card-name">{t('VIEW_ALL') || 'View All'}</span>
                    </div>
                </Link>
            </div>
        </section>
    );
};

export default CategorySection;
